import { useTranslation } from "react-i18next";
import { Purchases as PurchasesFeature } from "@/partner/features/purchases";
import { Meta } from "@/shared/components";

export function PurchasesPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("purchases.pageTitle")} pageType="Partner" />
      <PurchasesFeature />
    </>
  );
}
